/* eslint class-methods-use-this: 0 */

// constants
import { PLACES_FIELD } from './Constants';

class PlaceUtils {
  /**
   * @description Focus the next field
   *
   * @param {integer} index - nth occurrence of the previous field
   *
   * @return {void}
   */
  focusNextField(index) {
    const formItem = document.getElementsByClassName(PLACES_FIELD);
    const formsLen = formItem.length - 1;
    if (index + 1 <= formsLen) {
      formItem[index + 1].focus();
    } else {
      document.activeElement.blur();
    }
  }

  /**
   * @description Focus the next empty field
   *
   * @param {string} value - Input field value
   *
   * @return {Object} DOM of the first empty field
   */
  setFirstEmptyField(value) {
    const fields = document.getElementsByClassName(PLACES_FIELD);
    let field = null;

    let i = 0;
    const fieldsLen = fields.length;
    for (i; i < fieldsLen; i += 1) {
      if (!fields[i].value) {
        field = fields[i];
        break;
      }
    }

    if (field) field.value = value;

    return field;
  }

  /**
   * @description Checks a collection of fields to determine if at least one of them has a value
   *
   * @param {Array} fields - fields to be checked
   *
   * @return {boolean} true when a field has data
   */
  oneFieldHasData(fields) {
    let i = 0;
    const fieldLen = fields.length;
    for (i; i < fieldLen; i += 1) {
      if (fields[i].lat && fields[i].lng) return true;
    }

    return false;
  }
}

export default new PlaceUtils();
